/* tslint:disable */
/* eslint-disable */
/* @relayHash 908073272a8f5f0cee897ec35ed83723 */

import { ConcreteRequest } from "relay-runtime";
export type CompleteAccountEmailInput = {
    email: string;
    clientMutationId?: string | null;
};
export type completeAccountEmailMutationVariables = {
    input: CompleteAccountEmailInput;
};
export type completeAccountEmailMutationResponse = {
    readonly completeAccountEmail: {
        readonly message: string | null;
    } | null;
};
export type completeAccountEmailMutation = {
    readonly response: completeAccountEmailMutationResponse;
    readonly variables: completeAccountEmailMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "CompleteAccountEmailInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "completeAccountEmail",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CompleteAccountEmailPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "completeAccountEmailMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "completeAccountEmailMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "completeAccountEmailMutation",
    "id": "ferrum/255.0.0-2020-03-10T14:28:54.909Z/completeAccountEmailMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '883b4525d2b17ac04896e764ae2e1f1b';
export default node;
